if (!customElements.get('custom-drawer')) {
  customElements.define('custom-drawer', class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      // Generate a unique ID if none is provided
      if (!this.getAttribute('id')) {
        this.setAttribute('id', `drawer-${Math.random().toString(36).substr(2, 9)}`);
      }

      // Get the section ID from data attribute
      this.sectionId = this.dataset.drawerId;
      
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      
      // Add click event listener to the entire drawer area
      this.addEventListener('click', (evt) => {
        // Close only if clicking the overlay (background) area
        if (evt.target === this) {
          this.close();
        }
      });

      // Add global click listener for drawer triggers
      document.addEventListener('click', (evt) => {
        const trigger = evt.target.closest('[data-drawer-trigger]');
        if (trigger) {
          this.open(trigger);
        }
      });
      
      // Move drawer to body when constructed
      this.moveToBody();
    }
    
    // New method to move drawer to body
    moveToBody() {
      // Only move if not already at body level
      if (this.parentElement && this.parentElement.tagName !== 'BODY' && !this.parentElement.classList.contains('custom-drawer-container')) {
        // Create container if it doesn't exist
        let container = document.querySelector('body > .custom-drawer-container');
        if (!container) {
          container = document.createElement('div');
          container.classList.add('custom-drawer-container');
          document.body.appendChild(container);
        }
        
        // Move this drawer to the container
        container.appendChild(this);
      }
    }

    open(triggeredBy) {
      // Ensure drawer is at body level before opening
      this.moveToBody();
      
      // Only open if the trigger belongs to this section
      if (triggeredBy && triggeredBy.closest(`[data-section-id="${this.sectionId}"]`)) {
        this.setActiveElement(triggeredBy);
        
        requestAnimationFrame(() => {
          this.classList.add('animate');
          requestAnimationFrame(() => {
            this.classList.add('active');
          });
        });

        document.body.classList.add('overflow-hidden');
      }
    }

    close() {
      this.classList.remove('active');
      this.addEventListener('transitionend', () => {
        this.classList.remove('animate');
      }, { once: true });
      
      document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  });
}